import { render, staticRenderFns } from "./TCFDTable.vue?vue&type=template&id=7596f997&scoped=true"
import script from "./TCFDTable.vue?vue&type=script&lang=js"
export * from "./TCFDTable.vue?vue&type=script&lang=js"
import style0 from "./TCFDTable.vue?vue&type=style&index=0&id=7596f997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7596f997",
  null
  
)

export default component.exports